import React, { useState, useEffect, useCallback, useContext } from 'react'
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'
import DatePicker, { CalendarContainer } from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { AppColors } from '../css/AppColors';
import { Modal, Button, Form } from 'react-bootstrap';
import { apiRequest } from '../utils/apiCalls';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import { Context } from '../Context/DataContext';
import { useHistory, useLocation } from 'react-router';
import BackButton from '../Components/BackButton';
import { Col, Row, Container } from 'react-bootstrap'


const useForceUpdate = () => {
    const [, updateState] = React.useState();
    return useCallback(() => updateState({}), []);
}



const ViewSinglePresc = () => {


    const forceUpdate = useForceUpdate()
    const history = useHistory();
    const [startDate, setStartDate] = useState(new Date());
    var location = useLocation();
    // console.log(location)
    const { state } = useContext(Context)

    const [selectedDate, setSelectedDate] = useState(new Date())
    const [loading, setLoading] = useState(false)
    const [storeCustomers, setStoreCustomers] = useState([])


    const [pData, setPData] = useState({
        // st_id: state.storeData[0].st_id,
        id: location.state.id,
        patient_id: location?.state?.cust_id ? location.state.cust_id : '',
        prescriber: location?.state?.prescriber ? location.state.prescriber : '',
        prescription_date: location?.state?.prescription_date ? location.state.prescription_date : '',
        h_phone: location?.state?.h_phone ? location.state.h_phone : '',
        o_phone: location?.state?.o_phone ? location.state.o_phone : '',
        odsph: location?.state?.odsph ? location.state.odsph : '',
        odcyl: location?.state?.odcyl ? location.state.odcyl : '',
        odaxis: location?.state?.odaxis ? location.state.odaxis : '',
        odprism: location?.state?.odprism ? location.state.odprism : '',
        odfi: location?.state?.odfi ? location.state.odfi : '',
        odct: location?.state?.odct ? location.state.odct : '',
        ossph: location?.state?.ossph ? location.state.ossph : '',
        oscyl: location?.state?.oscyl ? location.state.oscyl : '',
        osaxis: location?.state?.osaxis ? location.state.osaxis : '',
        osprism: location?.state?.osprism ? location.state.osprism : '',
        osfi: location?.state?.osfi ? location.state.osfi : '',
        osct: location?.state?.osct ? location.state.osct : '',
        spect: location?.state?.spect ? location.state.spect : 0,
        dist: location?.state?.dist ? location.state.dist : 0,
        near: location?.state?.near ? location.state.near : 0,
        sv: location?.state?.sv ? location.state.sv : 0,
        protective_eyewear: location?.state?.protective_eyewear ? location.state.protective_eyewear : 0,
        contact_lenses_rx: location?.state?.contact_lenses_rx ? location.state.contact_lenses_rx : 0,
        bifocals: location?.state?.bifocals ? location.state.bifocals : 0,
        transitions: location?.state?.transitions ? location.state.transitions : 0,
        progressive: location?.state?.progressive ? location.state.progressive : 0,
    })

    function formatDate(dateObj) {

        if (dateObj.getMonth() < 10) {
            const month = "0" + dateObj.getMonth();
            if (dateObj.getDate() < 10) {
                const dat = "0" + dateObj.getDate();
                let date = dateObj.getFullYear() + "-" + month + "-" + dat;
                return date
                // props.onValueChange(date);
            }
            else {
                let date = dateObj.getFullYear() + "-" + month + "-" + dateObj.getDate()
                return date
                // props.onValueChange(date);
            }
        }
        else {
            if (dateObj.getDate() < 10) {
                const dat = "0" + dateObj.getDate()
                let date = dateObj.getFullYear() + "-" + dateObj.getMonth() + "-" + dat
                return date
                // props.onValueChange(date);
            }
            else {
                let date = dateObj.getFullYear() + "-" + dateObj.getMonth() + "-" + dateObj.getDate()
                return date
                // props.onValueChange(date);
            }

        }
    }


    function addPresc() {

        setLoading(true)
        console.log('pData = ')
        // console.log(pData)

        apiRequest(pData, 'editpresc')
            .then(data => {
                setLoading(false)
                // console.log(data)
                if (data.status == '1') {
                    alert('Prescription Updated')
                    history.replace('/viewCustomers')
                }
                else {
                    console.log('error is')
                    console.log(data.error.sqlMessage)
                    alert(data.error.sqlMessage)
                }
            })
            .catch(err => {
                setLoading(false)
                // console.log(err)
                alert('Internet Error')
            })



    }



    const ViewPresc = () => (

        <Container className="mt-4" >
            <Row>
                {/* <Col>
                    <Row className="editDetails">OD</Row>
                    <Row className="editDetails">OS</Row>
                </Col> */}
                <Col className="editDetails" ></Col>
                <Col className="editDetails" >Sph</Col>
                <Col className="editDetails" >Cyl</Col>
                <Col className="editDetails" >Axis</Col>
                <Col className="editDetails" >Prism</Col>
                <Col className="editDetails" >TSC</Col>
                <Col className="editDetails" >Dia</Col>
            </Row>

            <Row className="border-bottom border-secondary"  >
                <Col className="editDetails" style={{ fontSize: 20 }} >OD</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }}>{pData.odsph}</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }}>{pData.odcyl}</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }}>{pData.odaxis}</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }}>{pData.odprism}</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }}>{pData.odfi}</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }}>{pData.odct}</Col>
            </Row>

            <Row className="border-bottom border-secondary mt-2 " >
                <Col className="editDetails" style={{ fontSize: 20 }} >OS</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }} >{pData.ossph}</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }} >{pData.oscyl}</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }} >{pData.osaxis}</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }} >{pData.osprism}</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }} >{pData.osfi}</Col>
                <Col className="editDetails" style={{ fontFamily: 'PRe' }} >{pData.osct}</Col>
            </Row>
        </Container >



    )



    // useEffect(() => {
    //     getStoreCustomers()
    // }, [])



    return (
        <div id="page-top">
            <div id="wrapper" >
                <Sidebar />
                <div id="content-wrapper" class="d-flex flex-column">
                    <div id="content">
                        <Topbar />


                        <div className="container-fluid" >


                            <Modal
                                show={loading}
                                onHide={() => setLoading(false)}
                            >

                                <Modal.Body class="text-center" >
                                    <div
                                        class="text-center"
                                        class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                                </Modal.Body>

                            </Modal>
                            {/* Page Wrapper */}
                            <div id="wrapper" >
                                {/* Content Wrapper */}
                                <div id="content-wrapper" className="d-flex flex-column" style={{ paddingBottom: 200 }} >
                                    {/* Main Content */}
                                    <div id="content">
                                        {/* Begin Page Content */}
                                        <div className="container-fluid">
                                            {/* Page Heading */}
                                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                                <h1 className="h3 mb-0 text-gray-800">View Prescription</h1>
                                            </div>

                                            <div className="row">




                                                <Form style={{ marginTop: 20 }} >
                                                    <div className="editDetails" >Customer</div>
                                                    <Form.Control
                                                        className="col-sm-6 mb-3 mb-sm-0" size="md"
                                                        disabled={true}
                                                        value={location.state.cust_fname + " " + location.state.cust_lname}
                                                    >
                                                    </Form.Control>
                                                    <div class="row mt-2 mb-3 ">
                                                        <div className="col-sm-6">
                                                            <div className="editDetails" >Prescriber</div>
                                                            <Form.Control
                                                                // type="email"
                                                                value={pData.prescriber}
                                                                placeholder="Prescriber"
                                                                disabled={true}
                                                            />
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <div className="editDetails" >Prescription Date</div>
                                                            <DatePicker
                                                                style={{ margin: 0 }}
                                                                value={pData.prescription_date}
                                                                className="form-control"
                                                                selected={pData.prescription_date}
                                                                disabled={true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="row mt-2 mb-3 ">
                                                        <div className="col-sm-6">
                                                            <div className="editDetails" >H-Phone</div>
                                                            <Form.Control
                                                                // type="password"
                                                                value={pData.h_phone}
                                                                placeholder="H-Phone"
                                                                disabled={true}

                                                            />
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <div className="editDetails" >C-Phone</div>
                                                            <Form.Control
                                                                value={pData.o_phone}
                                                                disabled={true}
                                                                placeholder="C-Phone" />
                                                        </div>
                                                    </div>

                                                    <ViewPresc />


                                                    <div class="row mt-5 mb-3 ">
                                                        <Form.Group className="col-sm-2" id="formGridCheckbox">
                                                            <Form.Check
                                                                checked={pData.sv == '1' ? true : false}
                                                                disabled={true}
                                                                type="checkbox" label="SV" className="check-box" />
                                                        </Form.Group>
                                                        {/* <Form.Group className="col-sm-2" id="formGridCheckbox">
                                                            <Form.Check
                                                                checked={pData.protective_eyewear == '1' ? true : false}
                                                                disabled={true}
                                                                type="checkbox" label="PROTECTIVE EYEWER" className="check-box" />
                                                        </Form.Group> */}
                                                        <Form.Group className="col-sm-2" id="formGridCheckbox">
                                                            <Form.Check
                                                                checked={pData.contact_lenses_rx == '1' ? true : false}
                                                                disabled={true}
                                                                type="checkbox" label="CONTACT LENSES RX" className="check-box" />
                                                        </Form.Group>
                                                        {/* </div> */}
                                                        {/* <div class="row mt-2 mb-3 "> */}
                                                        {/* <Form.Group className="col-sm-2" id="formGridCheckbox">
                                                            <Form.Check
                                                                checked={pData.bifocals == '1' ? true : false}
                                                                disabled={true}
                                                                type="checkbox" label="BIFOCALS" className="check-box" />
                                                        </Form.Group>
                                                        <Form.Group className="col-sm-2" id="formGridCheckbox">
                                                            <Form.Check
                                                                checked={pData.transitions == '1' ? true : false}
                                                                disabled={true}
                                                                type="checkbox" label="TRANSITIONS" className="check-box" />
                                                        </Form.Group> */}
                                                        <Form.Group className="col-sm-2" id="formGridCheckbox">
                                                            <Form.Check
                                                                checked={pData.progressive == '1' ? true : false}
                                                                disabled={true}
                                                                type="checkbox" label="PROGRESSIVE" className="check-box" />
                                                        </Form.Group>

                                                    </div>


                                                </Form>



                                                {/* </form> */}
                                            </div>
                                            <BackButton />
                                        </div>
                                        {/* /.container-fluid */}
                                    </div>
                                    {/* End of Main Content */}
                                </div>
                                {/* End of Content Wrapper */}
                            </div>



                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewSinglePresc



{/* <div class="row mb-3 ">
<div className="col-sm-6 mt-3">
    <h3 style={{ color: 'grey' }} >OD</h3>
    <div className="editDetails mt-2 " >Sph</div>
    <Form.Control

        value={pData.odsph}
        className="col-sm-7 mt-2"
        placeholder="Sph"
        disabled={true}
    />
    <div className="editDetails mt-2" >Cyl</div>
    <Form.Control
        value={pData.odcyl}
        className="col-sm-7 mt-2"
        placeholder="Cyl"
        disabled={true}
    />
    <div className="editDetails mt-2 " >Axis</div>
    <Form.Control
        value={pData.odaxis}
        className="col-sm-7 mt-2"
        placeholder="Axis"
        disabled={true}
    />
    <div className="editDetails mt-2" >Prism</div>
    <Form.Control
        value={pData.odprism}
        className="col-sm-7 mt-2"
        placeholder="Prism"
        disabled={true}
    />
    <div className="editDetails mt-2" >Fi</div>
    <Form.Control
        value={pData.odfi}
        className="col-sm-7 mt-2"
        placeholder="Fi"
        disabled={true}
    />
    <div className="editDetails mt-2" >Ct</div>
    <Form.Control
        value={pData.odct}
        className="col-sm-7 mt-2"
        placeholder="Ct"
        disabled={true}
    />
</div>
<div className="col-sm-6 mt-3 ">
    <h3 style={{ color: 'grey' }}>OS</h3>
    <div className="editDetails mt-2" >Sph</div>
    <Form.Control
        value={pData.ossph}
        className="col-sm-7 mt-2"
        placeholder="Sph"
        disabled={true}
    />
    <div className="editDetails mt-2" >Cyl</div>
    <Form.Control
        value={pData.oscyl}
        className="col-sm-7 mt-2"
        placeholder="Cyl"
        disabled={true}
    />
    <div className="editDetails mt-2" >Axis</div>
    <Form.Control
        value={pData.osaxis}
        className="col-sm-7 mt-2"
        placeholder="Axis"
        disabled={true}
    />
    <div className="editDetails mt-2" >Prism</div>
    <Form.Control
        value={pData.osprism}
        className="col-sm-7 mt-2"
        placeholder="Prism"
        disabled={true}
    />
    <div className="editDetails mt-2" >Fi</div>
    <Form.Control
        value={pData.osfi}
        className="col-sm-7 mt-2"
        placeholder="Fi"
        disabled={true}
    />
    <div className="editDetails mt-2" >Ct</div>
    <Form.Control
        value={pData.osct}
        className="col-sm-7 mt-2"
        placeholder="Ct"
        disabled={true}
    />
</div>
</div>
<div class="row mt-2 mb-3 ">
<Form.Group
    className="col-sm-2" id="formGridCheckbox">
    <Form.Check
        checked={pData.spect == '1' ? true : false}
        disabled={true}
        type="checkbox" label="SPECTACLES" className="check-box" />
</Form.Group>

<Form.Group className="col-sm-2" id="formGridCheckbox">
    <Form.Check
        checked={pData.dist == '1' ? true : false}
        disabled={true}
        type="checkbox" label="DISTANCE" className="check-box" />
</Form.Group>
<Form.Group className="col-sm-2" id="formGridCheckbox">
    <Form.Check
        checked={pData.near == '1' ? true : false}
        disabled={true}
        type="checkbox" label="NEAR" className="check-box" />
</Form.Group>
</div> */}